module.exports = __webpack_public_path__ + "static/media/auditorias.bf5b1ad2.jpg";